












































































































































































import { Vue, Component, Prop, Watch, PropSync } from 'vue-property-decorator';
import editor from '@/components/common/summernote/Index.vue';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import { GetProductsGuidesResponse, NCPResponse, ProductsGuide, StandardCategory } from 'supporter';
import { MAX_ADDABLE_UPLOAD_IMAGE_COUNT, MAX_ALL_UPLOAD_IMAGE_COUNT } from '@/const/product';

@Component({
  components: {
    CompRadioButton,
    editor,
  },
})
export default class ImagesInformation extends Vue {
  @Prop({ required: true }) private product!: any;
  @Prop({ required: true }) private error!: any;
  @Prop({ required: true }) private contentUse!: string;
  @Prop({ required: true }) private html!: string;
  @Prop({ required: false }) private initProductGuide!: ProductsGuide;
  @Prop({ required: true }) immutableFields!: string[];
  @Prop({ required: true }) standardCategory!: StandardCategory;
  @PropSync('productGuide') private productGuideSync!: ProductsGuide;

  private selectedIndex: null | number = null;
  private movedPositionIndex: null | number = null;

  private startImageDrag({ dataTransfer }: DragEvent, selectedIndex: number) {
    dataTransfer.dropEffect = 'move';
    dataTransfer.effectAllowed = 'move';
    this.selectedIndex = selectedIndex;
  }

  private leaveImageDrag(index) {
    const draggableElements = [
      this.$refs.draggableMainElement,
      ...(this.$refs.draggableAddElement as []),
    ] as HTMLDivElement[];
    draggableElements[index].classList.remove('main-image-over', 'image-over-right', 'image-over-left');
  }

  private overImageDrag({ clientX }: DragEvent, overIndex) {
    const draggableElements = [
      this.$refs.draggableMainElement,
      ...(this.$refs.draggableAddElement as []),
    ] as HTMLDivElement[];
    const selectedElement = draggableElements[this.selectedIndex];
    const overElement = draggableElements[overIndex];

    if (selectedElement.classList.contains('main-image') || overElement.classList.contains('main-image')) {
      overElement.classList.add('main-image-over');

      return;
    }

    const { left: overImageLeft, width: overImageWidth } = overElement.getBoundingClientRect();
    const overElementCenter = overImageLeft + overImageWidth / 2;

    if (clientX < overElementCenter) {
      overElement.classList.add('image-over-left');
      overElement.classList.remove('image-over-right');
      this.movedPositionIndex = overIndex;
    } else {
      overElement.classList.add('image-over-right');
      overElement.classList.remove('image-over-left');
      this.movedPositionIndex = overIndex + 1;
    }
  }

  private endImageDrag({ dataTransfer }: DragEvent, droppedIndex: number) {
    const draggableElements = [
      this.$refs.draggableMainElement,
      ...(this.$refs.draggableAddElement as []),
    ] as HTMLDivElement[];
    const selectedIndex = this.selectedIndex;
    const productImages = [...this.product.mallProductImages];
    const selectedItem = productImages[selectedIndex];
    const droppedItem = productImages[droppedIndex];

    if (selectedItem.mainYn === 'Y') {
      selectedItem.mainYn = 'N';
      droppedItem.mainYn = 'Y';
      productImages[selectedIndex] = droppedItem;
      productImages[droppedIndex] = selectedItem;

      this.product.mallProductImages = productImages;
    } else if (droppedItem.mainYn === 'Y') {
      selectedItem.mainYn = 'Y';
      droppedItem.mainYn = 'N';
      productImages[selectedIndex] = droppedItem;
      productImages[droppedIndex] = selectedItem;

      this.product.mallProductImages = productImages;
    } else {
      const copyItem = { ...selectedItem };

      productImages[selectedIndex].deletedItem = true;
      productImages.splice(this.movedPositionIndex, 0, copyItem);
      this.product.mallProductImages = productImages.filter(({ deletedItem }) => !deletedItem);
    }

    draggableElements[droppedIndex].classList.remove('image-over-right', 'image-over-left', 'main-image-over');
    dataTransfer.dropEffect = 'false';
    dataTransfer.effectAllowed = 'false';
  }

  public readonly MAX_ADDABLE_UPLOAD_IMAGE_COUNT = MAX_ADDABLE_UPLOAD_IMAGE_COUNT;
  public readonly MAX_ALL_UPLOAD_IMAGE_COUNT = MAX_ALL_UPLOAD_IMAGE_COUNT;

  private showLiquorDutyTooltip = false;
  private liquorDutyTemplateType: 'DEFAULT' | 'CUSTOM' = 'DEFAULT';
  private liquorDutyTemplateOptions = {
    name: 'liquorDutyTemplate',
    data: [
      {
        id: 'liquorDutyTemplateCustom',
        value: 'CUSTOM',
        dispaly: 'PRODUCT_ADD_DIRECT_INPUT',
      },
      {
        id: 'liquorDutyTemplateDefault',
        value: 'DEFAULT',
        dispaly: 'PRODUCT_ADD_DEFAULT_TEMPLATE',
      },
    ],
  };

  private initEdit = true;
  private productGuideContent = '';

  @Watch('liquorDutyTemplateType')
  @Watch('standardCategory.originType')
  private async changeLiquorTemplateType() {
    if (this.standardCategory.originType !== 'LIQUOR') {
      this.productGuideSync = null;
      this.productGuideContent = '';
      return;
    }
    const isEditState = this.$route.name === 'EditProduct' && this.initProductGuide && this.initEdit;
    const isCustomTemplate = this.initProductGuide.content?.length > 0;
    if (isEditState && isCustomTemplate) {
      this.liquorDutyTemplateType = 'CUSTOM';
      this.productGuideSync = { ...this.product.initProductGuide };
      this.productGuideContent = this.productGuideSync.content;
      this.initEdit = false;
      return;
    }

    if (this.liquorDutyTemplateType === 'DEFAULT') {
      const { data }: NCPResponse<GetProductsGuidesResponse> = await this.$api.getProductsGuides({
        params: {
          partnerNo: 0,
          type: 'DELEGATION_BY_LIQUOR',
        },
      });
      this.productGuideSync = { ...data, content: null };
      this.productGuideContent = '';
    } else {
      this.productGuideSync =
        this.$route.name === 'EditProduct' ? { ...this.initProductGuide } : { type: 'DELEGATION_BY_LIQUOR' };
      this.productGuideContent = this.productGuideSync.content;
    }
  }

  private defaultEditorOptions = {
    placeholder: 'PRODUCT_ADD_EDITOR_PLACEHODER',
    imageFileSize: 10240,
    width: 961,
    toolbar: [
      ['fontsize', ['fontsize']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
      ['color', ['color']],
      ['para', ['paragraph']],
      ['height', ['height']],
      ['picture', ['link', 'picture', 'video']],
      ['misc', ['codeview']],
    ],
  };
  private editorOptions = {
    placeholder: 'PRODUCT_ADD_EDITOR_PLACEHODER',
    imageFileSize: 10240,
    width: 961,
    toolbar: [
      ['fontsize', ['fontsize']],
      ['style', ['bold', 'italic', 'underline', 'strikethrough', 'clear']],
      ['color', ['color']],
      ['para', ['paragraph']],
      ['height', ['height']],
      ['picture', ['link', 'picture', 'video']],
      ['misc', ['codeview']],
    ],
  };
  created() {
    this.editorOptions.placeholder = this.$t(this.editorOptions.placeholder) as string;
    this.defaultEditorOptions.placeholder = this.$t(this.defaultEditorOptions.placeholder) as string;
  }
  get hasMainImage() {
    return this.product.mallProductImages.some((item: any) => item.mainYn === 'Y');
  }
  get mainImage() {
    return this.product.mallProductImages.find((item: any) => item.mainYn === 'Y');
  }

  get canAddUploadImage() {
    const allImageLength = this.product.mallProductImages.length;

    return this.hasMainImage
      ? allImageLength < MAX_ALL_UPLOAD_IMAGE_COUNT
      : allImageLength < MAX_ADDABLE_UPLOAD_IMAGE_COUNT;
  }

  addFile(type: string) {
    if (type === 'MAIN') {
      const file = Array.from((this.$refs.mainImage as HTMLInputElement).files as FileList)[0];
      this.uploadFile(file, (data: any) => {
        this.product.mallProductImages.push({
          mainYn: 'Y',
          imageUrl: data.url,
        });
      });
    } else if (type === 'LIST') {
      const file = Array.from((this.$refs.listImage as HTMLInputElement).files as FileList)[0];
      if (file) {
        this.uploadFile(file, (data: any) => {
          this.product.mallProductListImage = data.url;
        });
      }
    } else {
      const files = Array.from((this.$refs.productImage as HTMLInputElement).files as FileList);
      const { length: additionalImageCount } = this.product.mallProductImages.filter(({ mainYn }) => mainYn === 'N');
      const isExceedUploadImageCount = additionalImageCount + files.length > MAX_ADDABLE_UPLOAD_IMAGE_COUNT;

      if (isExceedUploadImageCount) {
        alert(this.$t('PRODUCT_ADD_INVALID_UPLOAD_ADDABLE_IMAGE_COUNT', { count: MAX_ADDABLE_UPLOAD_IMAGE_COUNT }));

        const greaterIndex = MAX_ADDABLE_UPLOAD_IMAGE_COUNT - additionalImageCount;

        files.splice(greaterIndex);
      }

      files.forEach(file => {
        this.uploadFile(file, (data: any) => {
          this.product.mallProductImages.push({
            mainYn: 'N',
            imageUrl: data.url,
          });
        });
      });
    }
  }
  private uploadFile(file: any, callback: Function): void {
    if (file.size <= 10485760) {
      const data = new FormData();
      data.append('file', file);
      this.$api.postImages({ data, params: { mallNo: Number(this.product.mallNo) } }).then(res => {
        callback(res.data);
      });
    } else {
      alert(this.$t('PRODUCT_ADD_IMAGE_MAX_SIZE'));
      return;
    }
  }
  removeFile(type: string, index: number) {
    if (type === 'MAIN') {
      this.product.mallProductImages.splice(
        this.product.mallProductImages.findIndex((item: any) => item.mainYn === 'Y'),
        1,
      );
    } else if (type === 'LIST') {
      this.product.mallProductListImage = '';
    } else {
      this.product.mallProductImages.splice(index, 1);
    }
  }
  private liquorDutyTemplateOnChange({ html }: { html: string }) {
    this.productGuideSync.content = html;
  }
  private contentHeaderOnChange({ html }: { html: string }) {
    this.product.contentHeader = html;
  }

  private contentOnChange({ html }: { html: string }) {
    this.$emit('deleteError', ['INVALID_ADD_OPTION_IMAGE_YN', 'INVALID_CONTENT', 'NON_EDITABLE_CONTENT']);
    this.product.content = html;
  }

  private contentFooterOnChange({ html }: { html: string }) {
    this.product.contentFooter = html;
  }
  uploadMainImage() {
    if (this.product.mallNo) {
      this.$emit('deleteError', 'INVALID_IMAGE_MAIN');
      this.$forceUpdate();
      $('#mainImage').click();
    }
  }
}
